import {SkinsService} from "./types"

export class SkinsServiceHttp implements SkinsService {
	// Use fetch because file is placed in S3 Bucket
	getSkin = (source:string) => fetch(source).then((result) => result.text())
}